import { Configuration } from '../../../../clients/quipli-service/configuration/configuration';
import { Order } from '../../../../clients/quipli-service/order/order';
import { PaymentMethodType } from '../../../../clients/quipli-service/payment/payment';

export type StatusTransition =
  | 'approve'
  | 'reject'
  | 'on-rent'
  | 'off-rent'
  | 'collect-payment'
  | 'quote'
  | 'inventory-return'
  | 'reopen'
  | 'missed';

export const shouldPaymentModalShow = (
  order: Order,
  allowCombinedOffRentReturn: Configuration | undefined,
  currentStep: StatusTransition,
  anyProductsInventoryReturned: boolean = true,
) => {
  const isNotOnAccount = order.paymentMethod.type !== PaymentMethodType.OnAccount;
  const isInventoryReturnOrCombinedOffRentReturn =
    currentStep === 'inventory-return' ||
    (currentStep === 'off-rent' && allowCombinedOffRentReturn && allowCombinedOffRentReturn.value === '1');
  const hasBalance = order.invoices.some((invoice) => invoice.balance > 0);

  if (hasBalance && isNotOnAccount && isInventoryReturnOrCombinedOffRentReturn && anyProductsInventoryReturned) {
    return true;
  }

  return false;
};
